import { mountCounter } from '../components/counter.js';
import { mountSoundToggle } from '../components/soundToggle.js';
import { certify } from '../lib/api.js';
import { buildCertPath } from '../lib/url.js';

export function renderLanding(root, { presetName }) {
  root.innerHTML = `
    <div class="forensic-page">
      <header class="forensic-header">
        <span data-test="case-pill">● CASE #047-291-XB</span>
        <span class="forensic-spacer"></span>
        <span data-test="counter"></span>
        <button class="sound-toggle" data-test="sound-toggle"></button>
      </header>
      <main class="forensic-main">
        <div class="classified-tag">— CLASSIFIED —</div>
        <h1 class="forensic-title">OFFICIAL INVESTIGATION</h1>
        <p class="forensic-subhead">A scientifically rigorous evaluation conducted by the Gay Certification Board. Results are final and federally binding.<sup>*</sup></p>
        <form class="forensic-form" data-test="landing-form">
          <label class="forensic-label">SUBJECT IDENTIFICATION</label>
          <input class="forensic-input" data-test="name-input" type="text" placeholder="Enter subject's full name" maxlength="80" />
          <button class="forensic-cta" data-test="begin-btn" type="submit" disabled>▶ BEGIN VERIFICATION</button>
        </form>
        <div class="forensic-footnote"><sup>*</sup> not actually federally binding</div>
      </main>
    </div>
  `;

  mountCounter(root.querySelector('[data-test=counter]'));
  mountSoundToggle(root.querySelector('[data-test=sound-toggle]'));

  const input = root.querySelector('[data-test=name-input]');
  const btn = root.querySelector('[data-test=begin-btn]');
  if (presetName) {
    input.value = presetName;
    btn.disabled = false;
  }
  input.addEventListener('input', () => { btn.disabled = !input.value.trim(); });

  root.querySelector('[data-test=landing-form]').addEventListener('submit', async (e) => {
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true; btn.textContent = '▶ INITIATING…';
    try {
      const referrerId = new URLSearchParams(window.location.search).get('ref');
      const { id, slug } = await certify({ name: input.value.trim(), referrerId });
      window.history.pushState({}, '', buildCertPath({ slug, id }) + '?show=1');
      const { renderShow } = await import('./show.js');
      renderShow(root, { certId: id, justCertified: true });
    } catch (err) {
      btn.disabled = false; btn.textContent = '▶ BEGIN VERIFICATION';
      input.classList.add('shake');
      setTimeout(() => input.classList.remove('shake'), 400);
    }
  });
}
